import '~/assets/scss/individuals.scss';

import Filters from '~/js/modules/filters';
import getSwiperSlider from '~/js/modules/slider';
import StockChart from '~/js/modules/stock-chart';
import Accordion from '~/js/modules/accordion';
import '~/js/modules/online-request';
import '~/js/modules/promo-banner';
import '~/js/modules/product/funds-year-replace'

window.addEventListener(`DOMContentLoaded`, () => {
  const productsSliders = document.querySelectorAll(`.products__slider-mobile`);
  const productsChartBlocks = document.querySelectorAll(`.products__chart-block`);
  const filterButtons = document.querySelectorAll(`.filters__link`);
  const accordions = document.querySelectorAll(`.accordion`);
  // const forms = document.querySelectorAll(`.form__form`);
  const cart = document.querySelector('.js-cart');
  const buyButton = document.querySelectorAll(`.js-buy`);
  const buyPif = document.querySelector(`.js-buy-pif`);
  const cartButton = document.querySelector(`.js-cart-button`);
  const pifCounter = cartButton.querySelector(`.js-pif-counter`);
  const closeCart = cart.querySelector('.js-close-btn')
  const cartBody = cart.querySelector('.js-cart-body')
  const filtersControls = document.querySelectorAll(`.js-filters-controls`);

  const productContainers = document.querySelectorAll(`.products__cards`);
  if (productContainers.length) {
    productContainers.forEach((pc) => {
      let productCard = Array.from(pc.querySelectorAll('.products__slide'));

      productCard.forEach((card) => {
        card.dataset.growth = Number(card.dataset.growth.replace(',', '.'));
      });
      productCard.sort((a, b) => {
        return b.dataset.growth - a.dataset.growth;
      });

      productCard.forEach(productCard => pc.appendChild(productCard));
    });
  }

  let update_count = function (up = false) {
    let count = parseInt(pifCounter.textContent)
    let prevCount = count;

    if(up) {
      count++;
    }
    else {
      count--;
    }
    pifCounter.textContent = count.toString();
    cartButton.style.display = count ? 'flex' : 'none';
    if(prevCount == 0 && count == 1) {
      cart.classList.toggle('active');
    }
    if(count == 0) {
      cart.classList.remove('active')
    }
  }

  let delete_pif = function (opn) {
    let ids = buyPif.dataset.openLink.split('=')[1].split(',')
    if (ids.indexOf(opn) !== -1) {
      ids.splice(ids.indexOf(opn), 1);
    }
    buyPif.dataset.openLink = buyPif.dataset.openLink.split('=')[0] + '=' + ids.join(',')
    buyPif.dataset.openKidsLink = buyPif.dataset.openKidsLink.split('=')[0] + '=' + ids.join(',')
  }

  let add_pif = function (bb, e) {
    e.stopPropagation()
    e.preventDefault()
    bb.classList.toggle('active')

    if(bb.classList.contains('active')) {
      if(parseInt(pifCounter.textContent) != 0) {
        buyPif.dataset.openLink = buyPif.dataset.openLink + ',' + bb.dataset.openId
        buyPif.dataset.openKidsLink = buyPif.dataset.openKidsLink + ',' + bb.dataset.openId
      }
      else {
        buyPif.dataset.openLink = buyPif.dataset.openLink + bb.dataset.openId
        buyPif.dataset.openKidsLink = buyPif.dataset.openKidsLink + bb.dataset.openId
      }
      const newPif = document.createElement('div')
      const deletePif = document.createElement('button')
      const bottomContainer = document.createElement('div')
      const description = '<p class="description">' + bb.dataset.description + '</p>'
      let risk = ''
      update_count(true)

      deletePif.className = 'delete-button'
      deletePif.innerHTML = '<div class="circle">'
        + '<svg class="trs" xmlns="http://www.w3.org/2000/svg">'
        + '<use href="/assets/dist/img/sprite.svg#i-trash"></use>'
        + '</svg>'
        + '</div>';

      for(let i=1;i<=5;i++) {
        if(bb.dataset.risk >= i) {
          risk = risk + '<div class="risk active"></div>'
        }
        else {
          risk = risk + '<div class="risk"></div>'
        }
      }

      const percent = bb.parentNode.querySelector('.percent')

      bottomContainer.className = 'bottom-container'
      bottomContainer.appendChild(deletePif)

      newPif.className = 'pif-card'
      newPif.dataset.pif = bb.dataset.id
      newPif.innerHTML = '<div class="info-container">'
        + '<div class="head">'
        + '<span class="name">' + bb.dataset.name + '</span>'
        + '<div class="risk-container">'
        + risk
        + '</div>'
        + '</div>'
        + description
        + '<div class="growth-container">'
        + (percent ? percent.outerHTML : '')
        + (percent ? '<span class="date">с ' + bb.dataset.start + ' г.</span>' : '<span class="date">Фонд в стадии</br>формирования</span>')
        + '</div>'
        + '</div>'
        + description
      newPif.appendChild(bottomContainer)

      deletePif.addEventListener('click', (e) => {
        document.querySelector('[data-id="' + newPif.dataset.pif + '"]').classList.toggle('active')
        newPif.remove()
        delete_pif(bb.dataset.openId)
        update_count()
      })

      cartBody.appendChild(newPif)
    }
    else {
      delete_pif(bb.dataset.openId)
      document.querySelector('[data-pif="' + bb.dataset.id + '"]').remove()
      update_count()
    }
  }
  closeCart.addEventListener('click', (e) => {
    cart.classList.toggle('active')
  })

  cartButton.addEventListener('click', (e) => {
    cart.classList.toggle('active')
  })

  // Check for the presence of the `buyfund` parameter in the URL
  const urlParams = new URLSearchParams(window.location.search)
  if (urlParams.get('buyfund')) {
    const buyfundIds = urlParams.get('buyfund').split(',')
    buyfundIds.forEach((id) => {
      const targetButton = document.querySelector(`.js-buy[data-id="${id}"]`)
      if (targetButton) {
        add_pif(targetButton, new Event('click'));
      }
    })
  }

  buyButton.forEach((bb) => {
    if (bb) {
      bb.addEventListener('click', (e) => {
        add_pif(bb, e)
      })
    }
  });

  let productsSwipers = [{}, {}];

  if (accordions.length) {
    accordions.forEach((accordion) => {
      if (!accordion.classList.contains('main-nav__list') && !accordion.classList.contains('service-request--accordion')) {
        new Accordion(accordion)
      }
    });
  }

  const productsSwiperParams = {
    slidesPerView: `auto`,
    loop: false,
    autoplay: false,
    navigation: false,
    pagination: false,
  };

  if (window.innerWidth < 1024) {
    productsSliders.forEach((it, i) => {
      if (it) {
        productsSwipers[i] = getSwiperSlider(it, productsSwiperParams);
        it.swiper.update();
      }
    });

    if (filterButtons.length) {
      filterButtons.forEach((fb) => {
        fb.addEventListener('click', () => {
          productsSliders.forEach((it, i) => {
            if (it.swiper && it.swiper.initialized) {
              it.swiper.destroy();
            }
            productsSwipers[i] = setTimeout(getSwiperSlider, 100, it, productsSwiperParams);
          });
        })
      });
    }
  }

  if (filtersControls.length) {
    filtersControls.forEach((fc, i) => {
      new Filters(fc);

      productsSliders.forEach((it, i) => {
        if (it.swiper && it.swiper.initialized) {
          it.swiper.destroy();
        }
        productsSwipers[i] = setTimeout(getSwiperSlider, 100, it, productsSwiperParams);
      })
    });
  }

  const productsStockChartNames = [`MSFT`];
  const productsStockChartOptions = {
    credits: {
      enabled: false,
    },
    legend: {
      enabled: false,
    },
    navigator: {
      enabled: false,
    },
    plotOptions: {
      line: {
        enableMouseTracking: false
      },
    },
    rangeSelector: {
      enabled: false,
    },
    scrollbar: {
      enabled: false,
    },
    tooltip: {
      enabled: false,
    },
    xAxis: {
      crosshair: false,
      labels: {
        enabled: false,
      },
      lineWidth: 0,
      range: 365 * 24 * 60 * 60 * 1000, // 1 year
      tickLength: 0,
    },
    yAxis: {
      gridLineWidth: 0,
      labels: {
        enabled: false,
      },
    },
    series: [],
    seriesCounter: 0,
  };

  productsChartBlocks.forEach((chart, i) => {
    productsStockChartOptions.chart = {
      spacing: 0,
      width: chart.offsetWidth,
      height: chart.offsetHeight,
    };
    productsStockChartOptions.names = i >= productsStockChartNames.length - 1
      ? [productsStockChartNames[0]]
      : [productsStockChartNames[i]];

    return new StockChart({
      chart,
      options: productsStockChartOptions,
    });
  });

  window.addEventListener(`resize`, () => {
    if (window.innerWidth >= 1024) {
      productsSwipers.forEach((it) => {
        if (it.initialized) {
          it.destroy();
        }
      });
    } else {
      productsSwipers.forEach((it, i) => {
        if (!it.initialized) {
          productsSwipers[i] = getSwiperSlider(productsSliders[i], productsSwiperParams);
        }
      });
    }
  });
});
